import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export type SlackEventGroup = {
  channelID: string
  departments: string[]
  eventTypes: ('birthdays' | 'leave' | 'anniversaries')[]
}

export type SlackConfiguration = {
  slackToken: string
  languageCode: 'da' | 'en'
  eventGroups: SlackEventGroup[]
}

type SlackResponse = Partial<SlackConfiguration> & {
  slackConnectURL: string
}

export function getSlackIntegration(companyID: string): Promise<RequestResponse<SlackResponse>> {
  return secureRequest('GET', url('/v2/companies/' + companyID + '/notifiers/slack'))
}

export function putSlackIntegration(
  companyID: string,
  configuration: SlackConfiguration | null
): Promise<RequestResponse<SlackConfiguration>> {
  return secureRequest('PUT', url('/v2/companies/' + companyID + '/notifiers/slack'), {
    body: configuration,
  })
}

export function postSlackIntegration(companyID: string, code: string, state: string): Promise<RequestResponse> {
  return secureRequest('POST', url('/v2/companies/' + companyID + '/notifiers/slack'), {
    body: {
      code,
      state,
    },
  })
}
